/* ==========================================================================
   Immoderne — thème Shopify
   Reprend le comportement du site d'origine (layout.js, home.js, boutique.js,
   produit.js, panier.js, favoris.js, aide.js, wheel.js) en s'appuyant sur
   l'API Ajax du panier Shopify au lieu du stockage local.
   ========================================================================== */
(function () {
  'use strict';

  var IMMO = window.IMMO || {};
  var R = IMMO.routes || {};
  var S = IMMO.strings || {};
  var ROOT = (R.root || '/').replace(/\/$/, '');

  /* ------------------------------------------------------------- Utilitaires */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /** « 1 399 DH » : arrondi, espace des milliers, libellé réglable. */
  function money(cents) {
    var n = Math.round((Number(cents) || 0) / 100);
    var s = String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return s + ' ' + (IMMO.currency || 'DH');
  }

  function toast(message, kind) {
    var host = document.getElementById('toast-host');
    if (!host) {
      host = document.createElement('output');
      host.id = 'toast-host';
      host.className = 'toast-host';
      host.setAttribute('aria-live', 'polite');
      document.body.appendChild(host);
    }
    var el = document.createElement('p');
    el.className = 'toast toast--' + (kind || 'info');
    var icon = kind === 'success' ? 'fa-circle-check' : (kind === 'error' ? 'fa-circle-exclamation' : 'fa-circle-info');
    el.innerHTML = '<i class="fa-solid ' + icon + '" aria-hidden="true"></i><span>' + esc(message) + '</span>';
    host.appendChild(el);
    setTimeout(function () { el.classList.add('toast--out'); }, 2600);
    setTimeout(function () { el.remove(); }, 3100);
  }

  var store = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* mode privé */ } }
  };

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) { var err = new Error(j.description || j.message || 'Erreur'); err.data = j; throw err; }
        return j;
      });
    });
  }

  /* ------------------------------------------------------------------ Panier */
  var Cart = {
    data: null,
    get: function () {
      return fetch(ROOT + '/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { Cart.data = c; Cart.render(); return c; });
    },
    add: function (items) {
      return postJSON(ROOT + '/cart/add.js', { items: items }).then(function (res) { return Cart.get().then(function () { return res; }); });
    },
    change: function (key, qty) {
      return postJSON(ROOT + '/cart/change.js', { id: key, quantity: qty }).then(function (c) { Cart.data = c; Cart.render(); return c; });
    },
    update: function (body) {
      return postJSON(ROOT + '/cart/update.js', body).then(function (c) { Cart.data = c; Cart.render(); return c; });
    },
    clear: function () {
      return postJSON(ROOT + '/cart/clear.js', {}).then(function (c) { Cart.data = c; Cart.render(); return c; });
    },
    isGift: function (item) {
      return !!(item.properties && (item.properties._cadeau || item.properties['_cadeau'])) || Number(item.final_price) === 0;
    },
    hasPaid: function (c) {
      return (c.items || []).some(function (i) { return !Cart.isGift(i); });
    },
    render: function () {
      var c = Cart.data;
      if (!c) return;
      var count = c.item_count;
      var badge = document.getElementById('cart-count');
      if (badge) { badge.textContent = count; badge.dataset.empty = count ? '0' : '1'; }
      var dCount = document.getElementById('drawer-count');
      if (dCount) dCount.textContent = count + (count > 1 ? ' articles' : ' article');
      var body = document.getElementById('drawer-body');
      var foot = document.getElementById('drawer-foot');
      if (body) body.innerHTML = drawerBody(c);
      if (foot) foot.innerHTML = drawerFoot(c);
    }
  };
  window.ImmoCart = Cart;

  function drawerBody(c) {
    if (!c.items.length) {
      return '<div class="empty-state">' +
        '<i class="fa-solid fa-bag-shopping" aria-hidden="true"></i>' +
        '<h2 style="font-size:1.1rem">Votre panier est vide</h2>' +
        '<p class="muted">Parcourez nos rayons et ajoutez vos coups de cœur.</p>' +
        '<a class="btn btn--primary" href="' + esc(R.allProducts || '/collections/all') + '">Découvrir la boutique</a>' +
      '</div>';
    }
    return c.items.map(function (line) {
      var img = line.image ? line.image + (line.image.indexOf('?') === -1 ? '?' : '&') + 'width=200&height=200&crop=center' : '';
      var opts = (line.options_with_values || []).filter(function (o) { return o.name !== 'Title'; })
        .map(function (o) { return esc(o.name) + ' : ' + esc(o.value); }).join(' · ');
      if (Cart.isGift(line)) {
        return '<div class="cart-line cart-line--gift" data-key="' + esc(line.key) + '" style="grid-template-columns:72px 1fr auto">' +
          (img ? '<span class="cart-line__thumb" style="width:72px"><img src="' + esc(img) + '" alt="' + esc(line.product_title) + '" loading="lazy"></span>' : '<span></span>') +
          '<div><p class="cart-line__name" style="margin:0"><span class="pill pill--mint" style="font-size:.68rem;vertical-align:middle"><i class="fa-solid fa-gift" aria-hidden="true"></i> Cadeau</span> ' + esc(line.product_title) + '</p>' +
          '<p class="muted" style="margin:.2rem 0 0;font-size:.82rem">Offert — 1 par commande</p></div>' +
          '<div class="cart-line__right"><span class="cart-line__price" style="color:#047857">Offert</span>' +
          '<button type="button" class="link-remove" data-remove>Supprimer</button></div></div>';
      }
      return '' +
        '<div class="cart-line" data-key="' + esc(line.key) + '" style="grid-template-columns:72px 1fr auto">' +
          '<a href="' + esc(line.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(line.product_title) + '" loading="lazy">' : '') + '</a>' +
          '<div>' +
            '<p class="cart-line__name" style="margin:0"><a href="' + esc(line.url) + '">' + esc(line.product_title) + '</a></p>' +
            (opts ? '<p class="cart-line__opts" style="margin:.15rem 0 0">' + opts + '</p>' : '') +
            '<div class="qty" style="margin-top:.45rem;transform:scale(.9);transform-origin:left">' +
              '<button type="button" data-step="-1" aria-label="Diminuer la quantité"><i class="fa-solid fa-minus" aria-hidden="true"></i></button>' +
              '<input type="number" value="' + line.quantity + '" min="0" aria-label="Quantité pour ' + esc(line.product_title) + '">' +
              '<button type="button" data-step="1" aria-label="Augmenter la quantité"><i class="fa-solid fa-plus" aria-hidden="true"></i></button>' +
            '</div>' +
          '</div>' +
          '<div class="cart-line__right">' +
            '<span class="cart-line__price">' + money(line.final_line_price) + '</span>' +
            '<button type="button" class="link-remove" data-remove>Supprimer</button>' +
          '</div>' +
        '</div>';
    }).join('');
  }

  function drawerFoot(c) {
    if (!c.items.length) return '';
    var threshold = (Number(IMMO.freeShippingThreshold) || 0) * 100;
    var subtotal = c.items_subtotal_price;
    var missing = Math.max(0, threshold - subtotal);
    var pct = threshold > 0 ? Math.min(100, Math.round(subtotal / threshold * 100)) : 100;
    var discounts = (c.cart_level_discount_applications || []).map(function (d) {
      return '<div class="summary__row" style="color:#047857"><span>Remise ' + esc(d.title) + '</span><strong>-' + money(d.total_allocated_amount) + '</strong></div>';
    }).join('');
    var paid = Cart.hasPaid(c);
    return '' +
      (missing > 0
        ? '<p style="margin:0 0 .35rem;font-size:.86rem">Encore <strong>' + money(missing) + '</strong> pour la livraison offerte !</p>' +
          '<div class="progress"><div class="progress__fill" style="width:' + pct + '%"></div></div>'
        : '<p class="pill pill--mint" style="margin:0 0 .5rem"><i class="fa-solid fa-truck-fast" aria-hidden="true"></i> Livraison offerte débloquée</p>') +
      '<div class="summary__row"><span>Sous-total</span><strong>' + money(subtotal) + '</strong></div>' +
      discounts +
      '<div class="summary__row summary__row--total"><span>Total estimé</span><span>' + money(c.total_price) + '</span></div>' +
      (paid
        ? '<a class="btn btn--primary btn--block btn--lg" href="' + ROOT + '/checkout" style="margin-top:.85rem"><i class="fa-solid fa-circle-check" aria-hidden="true"></i> Commander</a>'
        : '<button type="button" class="btn btn--quiet btn--block btn--lg" disabled style="margin-top:.85rem"><i class="fa-solid fa-lock" aria-hidden="true"></i> Ajoutez un produit pour commander</button>') +
      '<a class="btn btn--ghost btn--block btn--sm" href="' + esc(R.cart || '/cart') + '" style="margin-top:.5rem">Voir mon panier</a>' +
      '<button type="button" class="btn btn--quiet btn--block btn--sm" data-clear-cart style="margin-top:.25rem">Vider le panier</button>';
  }

  /* ----------------------------------------------------- Tiroir & menu mobile */
  function openDrawer() {
    var d = document.getElementById('cart-drawer');
    var b = document.getElementById('drawer-backdrop');
    var t = document.getElementById('cart-toggle');
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    if (b) { b.hidden = false; b.classList.add('is-open'); }
    if (t) t.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    var close = document.getElementById('cart-close');
    if (close) close.focus();
  }
  function closeDrawer() {
    var d = document.getElementById('cart-drawer');
    var b = document.getElementById('drawer-backdrop');
    var t = document.getElementById('cart-toggle');
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    if (b) { b.classList.remove('is-open'); b.hidden = true; }
    if (t) t.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
  function openMenu() {
    var p = document.getElementById('mobile-panel');
    if (!p) return;
    p.classList.add('is-open');
    p.setAttribute('aria-hidden', 'false');
    var t = document.getElementById('menu-toggle');
    if (t) t.setAttribute('aria-expanded', 'true');
  }
  function closeMenu() {
    var p = document.getElementById('mobile-panel');
    if (!p) return;
    p.classList.remove('is-open');
    p.setAttribute('aria-hidden', 'true');
    var t = document.getElementById('menu-toggle');
    if (t) t.setAttribute('aria-expanded', 'false');
  }

  /* --------------------------------------------------------------- Favoris */
  var WL_KEY = 'immo.wishlist.v1';
  var Wishlist = {
    ids: function () { var l = store.get(WL_KEY, []); return Array.isArray(l) ? l : []; },
    has: function (h) { return Wishlist.ids().indexOf(h) !== -1; },
    toggle: function (h) {
      var ids = Wishlist.ids();
      var i = ids.indexOf(h);
      if (i === -1) ids.push(h); else ids.splice(i, 1);
      store.set(WL_KEY, ids);
      return i === -1;
    },
    clear: function () { store.set(WL_KEY, []); },
    sync: function () {
      var n = Wishlist.ids().length;
      $$('[data-wishlist-count]').forEach(function (el) { el.textContent = n; el.dataset.empty = n ? '0' : '1'; });
      $$('[data-fav]').forEach(function (btn) {
        var on = Wishlist.has(btn.dataset.fav);
        btn.classList.toggle('is-active', on);
        var icon = btn.querySelector('i');
        if (icon) icon.className = (on ? 'fa-solid' : 'fa-regular') + ' fa-heart';
        btn.setAttribute('aria-label', on ? 'Retirer des favoris' : 'Ajouter aux favoris');
      });
    }
  };

  function renderWishlistPage() {
    var root = document.querySelector('[data-wishlist-root]');
    if (!root) return;
    var shopUrl = R.allProducts || '/collections/all';
    var ids = Wishlist.ids();
    var sub = document.getElementById('page-subtitle');
    if (!ids.length) {
      root.innerHTML = '<div class="empty-state"><i class="fa-regular fa-heart" aria-hidden="true"></i>' +
        '<h2>Votre liste de favoris est vide</h2>' +
        '<p class="muted">Touchez le cœur sur une fiche produit pour la retrouver ici.</p>' +
        '<a class="btn btn--primary btn--lg" href="' + esc(shopUrl) + '">Explorer la boutique</a></div>';
      return;
    }
    Promise.all(ids.map(function (h) {
      return fetch(ROOT + '/products/' + encodeURIComponent(h) + '?view=card')
        .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (cards) {
      var html = cards.filter(Boolean).join('');
      if (!html) {
        root.innerHTML = '<div class="empty-state"><i class="fa-regular fa-heart" aria-hidden="true"></i>' +
          '<h2>Vos favoris ne sont plus disponibles</h2><a class="btn btn--primary" href="' + esc(shopUrl) + '">Voir la boutique</a></div>';
        return;
      }
      var n = cards.filter(Boolean).length;
      if (sub) sub.textContent = n + ' produit' + (n > 1 ? 's' : '') + ' mis de côté, conservé' + (n > 1 ? 's' : '') + ' sur cet appareil.';
      root.innerHTML =
        '<div style="display:flex;gap:.6rem;flex-wrap:wrap;margin-bottom:1.25rem">' +
          '<button type="button" class="btn btn--primary" id="fav-add-all"><i class="fa-solid fa-cart-plus" aria-hidden="true"></i> Tout ajouter au panier</button>' +
          '<button type="button" class="btn btn--quiet" id="fav-clear"><i class="fa-regular fa-trash-can" aria-hidden="true"></i> Vider la liste</button>' +
        '</div>' +
        '<div class="product-grid">' + html + '</div>';
      Wishlist.sync();
      $('#fav-add-all').addEventListener('click', function () {
        var items = $$('[data-add]', root).filter(function (b) { return !b.disabled; })
          .map(function (b) { return { id: Number(b.dataset.add), quantity: 1 }; });
        if (!items.length) { toast(S.soldOut, 'error'); return; }
        Cart.add(items).then(function () {
          toast(items.length + ' produit' + (items.length > 1 ? 's ajoutés' : ' ajouté') + ' au panier.', 'success');
          openDrawer();
        }).catch(function (e) { toast(e.message || S.addError, 'error'); });
      });
      $('#fav-clear').addEventListener('click', function () {
        Wishlist.clear(); Wishlist.sync(); renderWishlistPage();
      });
    });
  }

  /* -------------------------------------------------------------- Clics globaux */
  document.addEventListener('click', function (e) {
    var t = e.target;

    if (t.closest('#menu-toggle')) { openMenu(); return; }
    if (t.closest('#menu-close')) { closeMenu(); return; }
    if (t.closest('#cart-toggle')) {
      // Sur la page panier, le lien mène simplement au panier.
      if (document.querySelector('[data-cart-section]')) return;
      e.preventDefault(); openDrawer(); return;
    }
    if (t.closest('#cart-close') || t.closest('#drawer-backdrop')) { closeDrawer(); return; }
    if (t.closest('#to-top')) { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }

    // Favoris
    var fav = t.closest('[data-fav]');
    if (fav) {
      e.preventDefault();
      var added = Wishlist.toggle(fav.dataset.fav);
      toast(added ? S.favAdded : S.favRemoved, added ? 'success' : 'info');
      Wishlist.sync();
      return;
    }

    // Ajout rapide depuis une carte
    var add = t.closest('[data-add]');
    if (add) {
      e.preventDefault();
      add.disabled = true;
      Cart.add([{ id: Number(add.dataset.add), quantity: 1 }]).then(function () {
        toast((S.added || '%s').replace('%s', add.dataset.title || ''), 'success');
        openDrawer();
      }).catch(function (err) { toast(err.message || S.addError, 'error'); })
        .finally(function () { add.disabled = false; });
      return;
    }

    // « Acheter maintenant » depuis une carte : ajout puis paiement direct
    var buy = t.closest('[data-buynow]');
    if (buy) {
      e.preventDefault();
      buy.disabled = true;
      Cart.add([{ id: Number(buy.dataset.buynow), quantity: 1 }]).then(function () {
        window.location.href = ROOT + '/checkout';
      }).catch(function (err) { toast(err.message || S.addError, 'error'); buy.disabled = false; });
      return;
    }

    // Tiroir : quantités / suppression / vider
    var drawer = t.closest('#cart-drawer');
    if (drawer) {
      var step = t.closest('[data-step]');
      var rm = t.closest('[data-remove]');
      var line = t.closest('.cart-line');
      if (step && line) {
        var input = line.querySelector('input[type="number"]');
        Cart.change(line.dataset.key, Math.max(0, (Number(input.value) || 0) + Number(step.dataset.step)));
        return;
      }
      if (rm && line) { Cart.change(line.dataset.key, 0).then(function () { toast(S.removed, 'info'); }); return; }
    }
    if (t.closest('[data-clear-cart]')) {
      Cart.clear().then(function () { toast(S.cleared, 'info'); refreshCartSection(); });
      return;
    }

    // Copier le code promo
    var copy = t.closest('[data-copy-code]');
    if (copy) {
      var code = copy.dataset.copyCode;
      var done = function () { toast('Code ' + code + ' copié. Collez-le dans votre panier !', 'success'); };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(function () { toast('Code : ' + code, 'info'); });
      } else { toast('Code : ' + code, 'info'); }
      return;
    }

    // FAQ
    var q = t.closest('.faq__q');
    if (q) {
      var item = q.closest('.faq__item');
      var panel = item.querySelector('.faq__a');
      var open = item.classList.toggle('is-open');
      panel.hidden = !open;
      q.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }

    // Panneaux d'information (fiche produit)
    var ph = t.closest('.info-panel__head');
    if (ph) {
      var ip = ph.closest('.info-panel');
      var ob = ip.classList.toggle('is-open');
      ip.querySelector('.info-panel__body').hidden = !ob;
      ph.setAttribute('aria-expanded', ob ? 'true' : 'false');
      return;
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('#cart-drawer .cart-line input[type="number"]');
    if (input) {
      var line = input.closest('.cart-line');
      Cart.change(line.dataset.key, Math.max(0, Number(input.value) || 0));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeMenu(); }
    if (e.key === '/' && !/input|textarea|select/i.test(document.activeElement.tagName)) {
      var s = document.getElementById('header-search');
      if (s && s.offsetParent) { e.preventDefault(); s.focus(); }
    }
  });

  /* ------------------------------------------------------------ Page panier */
  function cartSectionEl() { return document.querySelector('[data-cart-section]'); }

  function refreshCartSection() {
    var el = cartSectionEl();
    if (!el) return Promise.resolve();
    var id = el.dataset.cartSection;
    return fetch((R.cart || '/cart') + '?sections=' + encodeURIComponent(id))
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var html = json[id];
        if (!html) { window.location.reload(); return; }
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-cart-section]');
        if (fresh) el.replaceWith(fresh);
      }).catch(function () { window.location.reload(); });
  }

  function initCartPage() {
    if (!cartSectionEl()) return;
    document.addEventListener('click', function (e) {
      var sec = e.target.closest('[data-cart-section]');
      if (!sec) return;
      var line = e.target.closest('.cart-line');
      var step = e.target.closest('[data-step]');
      var rm = e.target.closest('[data-remove]');
      if (step && line) {
        var input = line.querySelector('input[type="number"]');
        Cart.change(line.dataset.key, Math.max(0, (Number(input.value) || 0) + Number(step.dataset.step))).then(refreshCartSection);
        return;
      }
      if (rm && line) {
        Cart.change(line.dataset.key, 0).then(function () { toast(S.removed, 'info'); return refreshCartSection(); });
        return;
      }
      if (e.target.closest('[data-promo-apply]')) {
        var inp = sec.querySelector('[data-promo-input]');
        var code = (inp.value || '').trim().toUpperCase();
        if (!code) { toast('Saisissez un code promo.', 'error'); inp.focus(); return; }
        Cart.update({ discount: code }).then(function (c) {
          var dc = (c.discount_codes || []).filter(function (d) { return String(d.code).toUpperCase() === code; })[0];
          if (dc && dc.applicable) toast('Code ' + code + ' appliqué.', 'success');
          else toast('Le code ' + code + ' n’est pas valable pour ce panier (montant minimum ou code inconnu).', 'error');
          return refreshCartSection();
        }).catch(function () {
          // Repli : le code est transmis au paiement.
          window.location.href = ROOT + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(R.cart || '/cart');
        });
        return;
      }
      if (e.target.closest('[data-promo-remove]')) {
        Cart.update({ discount: '' }).then(refreshCartSection);
        return;
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('[data-promo-input]')) {
        e.preventDefault();
        var b = document.querySelector('[data-promo-apply]');
        if (b) b.click();
      }
    });
    document.addEventListener('change', function (e) {
      var sec = e.target.closest('[data-cart-section]');
      if (!sec) return;
      if (e.target.matches('.cart-line input[type="number"]')) {
        var line = e.target.closest('.cart-line');
        Cart.change(line.dataset.key, Math.max(0, Number(e.target.value) || 0)).then(refreshCartSection);
      }
      if (e.target.matches('[data-zone]')) {
        Cart.update({ attributes: { 'Zone de livraison': e.target.value } }).then(refreshCartSection);
      }
    });
  }

  /* ---------------------------------------------------------- Accueil : onglets */
  function initTabs() {
    $$('[data-tabs]').forEach(function (sec) {
      sec.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-tab]');
        if (!btn) return;
        var n = btn.dataset.tab;
        $$('[data-tab]', sec).forEach(function (b) {
          var on = b.dataset.tab === n;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        $$('[data-panel]', sec).forEach(function (p) { p.hidden = p.dataset.panel !== n; });
      });
    });
  }

  /* ------------------------------------------------------- Boutique (collection) */
  function initCollection() {
    var filters = document.getElementById('filters');
    var layout = document.getElementById('shop-layout');
    var toggle = document.getElementById('filter-toggle');
    var form = document.getElementById('filters-form');
    var compact = window.matchMedia('(max-width: 980px)').matches;

    if (filters && toggle) {
      var open = !compact;
      var sync = function () {
        filters.hidden = !open;
        filters.classList.toggle('is-open', open);
        if (layout) layout.classList.toggle('is-collapsed', !open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      };
      sync();
      toggle.addEventListener('click', function () {
        open = !open; sync();
        if (open && window.matchMedia('(max-width: 980px)').matches) {
          filters.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    var fam = document.getElementById('famnav');
    var famT = document.getElementById('famnav-toggle');
    if (fam && famT) {
      fam.classList.toggle('is-open', !compact);
      famT.setAttribute('aria-expanded', !compact ? 'true' : 'false');
      famT.addEventListener('click', function () {
        var o = !fam.classList.contains('is-open');
        fam.classList.toggle('is-open', o);
        famT.setAttribute('aria-expanded', o ? 'true' : 'false');
      });
    }
    var sub = document.getElementById('subnav');
    var subT = document.getElementById('subnav-toggle');
    if (sub && subT) {
      sub.classList.toggle('is-open', !compact);
      subT.setAttribute('aria-expanded', !compact ? 'true' : 'false');
      subT.addEventListener('click', function () {
        var o = !sub.classList.contains('is-open');
        sub.classList.toggle('is-open', o);
        subT.setAttribute('aria-expanded', o ? 'true' : 'false');
      });
    }

    if (form) {
      var submit = function () {
        var params = new URLSearchParams(new FormData(form));
        // Le curseur « prix max » à sa valeur maximale ne filtre rien.
        $$('[data-price-range]', form).forEach(function (r) {
          if (Number(r.value) >= Number(r.dataset.max)) params.delete(r.name);
          else { params.set(r.name, r.value); }
        });
        window.location.href = form.getAttribute('action') + '?' + params.toString();
      };
      form.addEventListener('change', submit);
      $$('[data-price-range]', form).forEach(function (r) {
        var out = r.parentNode.querySelector('output');
        r.addEventListener('input', function () { if (out) out.textContent = money(Number(r.value) * 100); });
      });
    }

    var sort = document.querySelector('[data-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }
  }

  /* -------------------------------------------------------------- Fiche produit */
  function initProduct() {
    var root = document.querySelector('[data-product-root]');
    if (!root) return;
    var dataEl = document.querySelector('[data-product-json]');
    var data = dataEl ? JSON.parse(dataEl.textContent) : { variants: [] };
    var form = document.getElementById('product-form');
    var idInput = form ? form.querySelector('[data-variant-id]') : null;
    var qtyInput = document.getElementById('qty-input');
    var buyBtn = document.getElementById('buy-now');
    var addBtn = document.getElementById('add-to-cart');
    var mainImg = document.getElementById('gallery-main');

    function selected() {
      return $$('.option-group', root).map(function (g) {
        var a = g.querySelector('.option-values button.is-active');
        return a ? a.dataset.value : null;
      });
    }
    function findVariant() {
      var sel = selected();
      if (!sel.length) return data.variants[0];
      return data.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      })[0];
    }
    function applyVariant(v) {
      if (!v) {
        if (buyBtn) { buyBtn.disabled = true; buyBtn.querySelector('span').textContent = 'Indisponible'; }
        if (addBtn) addBtn.disabled = true;
        return;
      }
      if (idInput) idInput.value = v.id;
      var box = root.querySelector('[data-price-box]');
      if (box) {
        var off = v.compare_at_price > v.price ? Math.round((1 - v.price / v.compare_at_price) * 100) : 0;
        box.innerHTML = '<strong data-price>' + money(v.price) + '</strong>' +
          (off > 0 ? '<s data-compare>' + money(v.compare_at_price) + '</s><span class="pill pill--accent" data-off>-' + off + '%</span>' : '');
      }
      $$('[data-sku]', root).forEach(function (s) { if (v.sku) s.textContent = v.sku; });
      if (buyBtn) { buyBtn.disabled = !v.available; buyBtn.querySelector('span').textContent = v.available ? 'Acheter maintenant' : 'Rupture de stock'; }
      if (addBtn) addBtn.disabled = !v.available;
      if (qtyInput) { if (v.qty) qtyInput.max = Math.max(1, v.qty); else qtyInput.removeAttribute('max'); }
      if (v.image && mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = v.image; }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    root.addEventListener('click', function (e) {
      var opt = e.target.closest('.option-values button');
      if (opt) {
        var group = opt.closest('.option-group');
        $$('.option-values button', group).forEach(function (b) { b.classList.toggle('is-active', b === opt); });
        var label = group.querySelector('.option-selected');
        if (label) label.textContent = opt.dataset.value;
        applyVariant(findVariant());
        return;
      }
      var st = e.target.closest('[data-qty-step]');
      if (st && qtyInput) {
        var max = Number(qtyInput.max) || 999;
        qtyInput.value = Math.min(max, Math.max(1, (Number(qtyInput.value) || 1) + Number(st.dataset.qtyStep)));
        return;
      }
    });

    function addCurrent() {
      var id = Number(idInput.value);
      var qty = Math.max(1, Number(qtyInput && qtyInput.value) || 1);
      return Cart.add([{ id: id, quantity: qty }]);
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addBtn.disabled = true;
        addCurrent().then(function () {
          toast((S.added || '%s').replace('%s', data.title), 'success');
          openDrawer();
        }).catch(function (err) { toast(err.message || S.addError, 'error'); })
          .finally(function () { addBtn.disabled = false; });
      });
    }
    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        buyBtn.disabled = true;
        addCurrent().then(function () { window.location.href = ROOT + '/checkout'; })
          .catch(function (err) { toast(err.message || S.addError, 'error'); buyBtn.disabled = false; });
      });
    }

    /* Galerie + visionneuse plein écran */
    var gEl = document.querySelector('[data-gallery]');
    var images = gEl ? JSON.parse(gEl.textContent || '[]') : [];
    var current = 0;
    $$('.gallery__thumbs button', root).forEach(function (b) {
      b.addEventListener('click', function () {
        current = Number(b.dataset.index) || 0;
        if (mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = b.dataset.main; mainImg.dataset.index = current; }
        $$('.gallery__thumbs button', root).forEach(function (x) { x.classList.toggle('is-active', x === b); });
      });
    });

    var lb = document.getElementById('lightbox');
    if (!lb || !images.length) return;
    var lbImg = document.getElementById('lightbox-img');
    var lbCount = document.getElementById('lightbox-count');
    var strip = document.getElementById('lightbox-strip');
    strip.innerHTML = images.map(function (src, i) {
      return '<button type="button" data-i="' + i + '" aria-label="Photo ' + (i + 1) + '"><img src="' + esc(src.replace(/width=\d+/, 'width=160')) + '" alt=""></button>';
    }).join('');
    function show(i) {
      current = (i + images.length) % images.length;
      lbImg.src = images[current];
      lbCount.textContent = (current + 1) + ' / ' + images.length;
      $$('button', strip).forEach(function (b) { b.classList.toggle('is-active', Number(b.dataset.i) === current); });
    }
    function openLb() { lb.hidden = false; document.body.classList.add('no-scroll'); show(Number(mainImg && mainImg.dataset.index) || current); }
    function closeLb() {
      lb.hidden = true; document.body.classList.remove('no-scroll');
      if (document.fullscreenElement && document.exitFullscreen) document.exitFullscreen();
    }
    if (mainImg) mainImg.addEventListener('click', openLb);
    var zoom = document.getElementById('gallery-zoom');
    if (zoom) zoom.addEventListener('click', openLb);
    document.getElementById('lightbox-close').addEventListener('click', closeLb);
    document.getElementById('lightbox-prev').addEventListener('click', function () { show(current - 1); });
    document.getElementById('lightbox-next').addEventListener('click', function () { show(current + 1); });
    document.getElementById('lightbox-full').addEventListener('click', function () {
      if (document.fullscreenElement) document.exitFullscreen();
      else if (lb.requestFullscreen) lb.requestFullscreen();
    });
    strip.addEventListener('click', function (e) { var b = e.target.closest('button'); if (b) show(Number(b.dataset.i)); });
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') closeLb();
      if (e.key === 'ArrowLeft') show(current - 1);
      if (e.key === 'ArrowRight') show(current + 1);
    });
    var x0 = null;
    lb.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
      x0 = null;
    });
  }

  /* ---------------------------------------------------- Roue « Gagner un cadeau » */
  function initWheel() {
    var modal = document.getElementById('wheel-modal');
    var openBtns = $$('[data-wheel-open]');
    if (!modal) { openBtns.forEach(function (b) { b.hidden = true; }); return; }
    if (!openBtns.length) return;

    var disc = document.getElementById('wheel-disc');
    var spinBtn = document.getElementById('wheel-spin');
    var resultEl = document.getElementById('wheel-result');
    var noteEl = document.getElementById('wheel-note');
    var bulbs = modal.querySelector('.wheel__bulbs');
    var prizesBox = document.getElementById('wheel-prizes');
    var prizesList = document.getElementById('wheel-prizes-list');
    var dataEl = document.getElementById('wheel-data');
    var cadeaux = [];
    try { cadeaux = JSON.parse(dataEl.textContent || '[]'); } catch (e) { cadeaux = []; }

    var COULEURS = ['#4b2fd6', '#ffffff', '#6f52ff', '#f3f1ff', '#3b2bb5', '#ffffff'];
    var TEXTE = ['#ffffff', '#241a63', '#ffffff', '#241a63', '#ffffff', '#241a63'];
    var SPIN_KEY = 'immo.giftspin.v1';
    var rotation = 0;
    var enCours = false;
    var cooldown = Number(IMMO.wheelCooldownHours) || 0;

    function dernierTour() { return Number(store.get(SPIN_KEY, 0)) || 0; }
    function peutJouer() { return cooldown <= 0 || Date.now() - dernierTour() > cooldown * 3600 * 1000; }
    function prochainTour() {
      if (cooldown <= 0) return 'Vous pouvez rejouer autant de fois que vous le souhaitez.';
      var reste = cooldown * 3600 * 1000 - (Date.now() - dernierTour());
      if (reste <= 0) return 'Vous pouvez retenter votre chance.';
      var h = Math.ceil(reste / 3600000);
      return 'Prochaine tentative possible dans ' + h + ' heure' + (h > 1 ? 's' : '') + '.';
    }
    function tirer() {
      var dispo = cadeaux.filter(function (c) { return Number(c.stock) !== 0; });
      if (!dispo.length) return null;
      var total = dispo.reduce(function (t, c) { return t + (Number(c.poids) || 1); }, 0);
      var seuil = Math.random() * total;
      for (var i = 0; i < dispo.length; i++) {
        seuil -= (Number(dispo[i].poids) || 1);
        if (seuil <= 0) return dispo[i];
      }
      return dispo[dispo.length - 1];
    }
    function dessiner() {
      var n = cadeaux.length;
      if (!n) return;
      var parts = 360 / n;
      var avecImage = n <= 8;
      disc.style.background = 'conic-gradient(' + cadeaux.map(function (c, i) {
        return COULEURS[i % COULEURS.length] + ' ' + (i * parts) + 'deg ' + ((i + 1) * parts) + 'deg';
      }).join(', ') + ')';
      disc.innerHTML = cadeaux.map(function (c, i) {
        var milieu = i * parts + parts / 2;
        var image = String(c.image_url || '').trim();
        return '<span class="wheel__label" style="--a:' + milieu + 'deg;--c:' + TEXTE[i % TEXTE.length] + '">' +
          '<span class="wheel__part">' +
            (image && avecImage ? '<img class="wheel__img" src="' + esc(image) + '" alt="" loading="lazy">' : '') +
            '<b class="wheel__name">' + esc(String(c.label || '').slice(0, 26)) + '</b>' +
          '</span></span>';
      }).join('');
      $$('.wheel__img', disc).forEach(function (img) { img.addEventListener('error', function () { img.remove(); }); });
      var html = '';
      for (var k = 0; k < 24; k++) {
        var a = (k * 15) * Math.PI / 180;
        html += '<i style="left:' + (50 + 49 * Math.cos(a)).toFixed(2) + '%;top:' + (50 + 49 * Math.sin(a)).toFixed(2) +
          '%;--d:' + (k * (1.7 / 24)).toFixed(2) + 's" class="' + (k % 2 ? 'is-alt' : '') + '"></i>';
      }
      bulbs.innerHTML = html;
      if (cadeaux.length >= 2) {
        prizesList.innerHTML = cadeaux.map(function (c) {
          return '<li>' + (c.image_url ? '<img src="' + esc(c.image_url) + '" alt="" loading="lazy">' : '') + '<span>' + esc(c.label) + '</span></li>';
        }).join('');
        prizesBox.hidden = false;
      }
    }
    function ouvrir() {
      modal.hidden = false;
      document.body.classList.add('no-scroll');
      if (!cadeaux.length) {
        disc.innerHTML = ''; disc.style.background = '#eee';
        resultEl.textContent = 'Aucun cadeau n’est disponible pour le moment. Revenez bientôt !';
        spinBtn.disabled = true;
        return;
      }
      if (spinBtn.dataset.done !== '1') resultEl.textContent = '';
      spinBtn.disabled = spinBtn.dataset.done === '1' ? false : !peutJouer();
      if (spinBtn.dataset.done !== '1') noteEl.textContent = prochainTour();
      dessiner();
    }
    function fermer() { modal.hidden = true; document.body.classList.remove('no-scroll'); }

    function ajouterCadeau(g) {
      // Un seul cadeau par panier : on retire l'éventuel cadeau précédent.
      var before = Cart.data ? Promise.resolve(Cart.data) : Cart.get();
      return before.then(function (c) {
        var olds = (c.items || []).filter(Cart.isGift);
        var chain = Promise.resolve();
        olds.forEach(function (o) { chain = chain.then(function () { return Cart.change(o.key, 0); }); });
        return chain;
      }).then(function () {
        return Cart.add([{ id: Number(g.id), quantity: 1, properties: { _cadeau: 'Roue « Gagner un cadeau »' } }]);
      });
    }

    function lancer() {
      if (enCours || !cadeaux.length) return;
      if (!peutJouer()) { resultEl.textContent = prochainTour(); return; }
      var gagnant = tirer();
      if (!gagnant) { resultEl.textContent = 'Aucun cadeau disponible pour le moment.'; return; }
      enCours = true;
      spinBtn.disabled = true;
      resultEl.textContent = 'La roue tourne…';
      var n = cadeaux.length, parts = 360 / n;
      var milieu = cadeaux.indexOf(gagnant) * parts + parts / 2;
      rotation += (5 + Math.floor(Math.random() * 3)) * 360 + (360 - milieu) + (Math.random() - 0.5) * (parts * 0.6);
      disc.style.transition = 'transform 4.4s cubic-bezier(.16,.84,.28,1)';
      disc.style.transform = 'rotate(' + rotation + 'deg)';
      setTimeout(function () {
        enCours = false;
        store.set(SPIN_KEY, Date.now());
        ajouterCadeau(gagnant).then(function () {
          toast('Cadeau gagné : ' + gagnant.label + ' !', 'success');
          noteEl.textContent = Cart.hasPaid(Cart.data)
            ? 'Votre cadeau est dans le panier.'
            : 'Ajoutez un produit à votre panier : une commande ne peut pas être validée avec le cadeau seul.';
        }).catch(function (err) { toast(err.message || 'Impossible d’ajouter le cadeau.', 'error'); });
        resultEl.innerHTML = '<span class="wheel-win">' +
          (gagnant.image_url ? '<img class="wheel-win__img" src="' + esc(gagnant.image_url) + '" alt="">' : '<i class="fa-solid fa-gift" aria-hidden="true"></i>') +
          '<span class="wheel-win__text">Vous avez gagné :<strong>' + esc(gagnant.label) + '</strong></span></span>';
        spinBtn.disabled = false;
        spinBtn.dataset.done = '1';
        spinBtn.innerHTML = '<i class="fa-solid fa-cart-shopping" aria-hidden="true"></i> Voir mon panier';
      }, 4600);
    }

    openBtns.forEach(function (b) { b.addEventListener('click', ouvrir); b.setAttribute('aria-haspopup', 'dialog'); });
    modal.addEventListener('click', function (e) { if (e.target.closest('[data-wheel-close]')) fermer(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) fermer(); });
    spinBtn.addEventListener('click', function () {
      if (spinBtn.dataset.done === '1' && !enCours) { window.location.href = R.cart || '/cart'; return; }
      lancer();
    });
  }

  /* ------------------------------------------------------------- Démarrage */
  function boot() {
    Cart.get().catch(function () { /* hors ligne */ });
    Wishlist.sync();
    renderWishlistPage();
    initTabs();
    initCollection();
    initProduct();
    initCartPage();
    initWheel();

    var top = document.getElementById('to-top');
    if (top) {
      window.addEventListener('scroll', function () { top.classList.toggle('is-visible', window.scrollY > 600); }, { passive: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
